export default __webpack_public_path__ + "static/media/check.bd089832.svg";